import { render, staticRenderFns } from "./VehicleCalculatorForm.vue?vue&type=template&id=23ff1504&scoped=true"
import script from "./VehicleCalculatorForm.vue?vue&type=script&lang=js"
export * from "./VehicleCalculatorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff1504",
  null
  
)

export default component.exports